import { STATIC_URL } from 'constants/data'

const Option = {
  watch: 'Посмотреть',
  read: 'Почитать',
  listen: 'Послушать',
  keyMoments: 'Ключевые моменты',
}

const OptionAliases = [
  {
    option: Option.watch,
    alias: 'watch',
  },
  {
    option: Option.read,
    alias: 'read',
  },
  {
    option: Option.listen,
    alias: 'listen',
  },
  {
    option: Option.keyMoments,
    alias: 'keyMoments',
  },
]

const Options = [Option.watch, Option.read, Option.listen, Option.keyMoments]

const OptionIcons = {
  [Option.watch]: {
    src: `${STATIC_URL}/icons/icon_video_2.svg`,
    width: 16,
    height: 16,
    alt: 'Посмотреть',
  },

  [Option.read]: {
    src: `${STATIC_URL}/icons/icon_book.svg`,
    width: 16,
    height: 16,
    alt: 'Почитать',
  },

  [Option.listen]: {
    src: `${STATIC_URL}/icons/icon_headphones.svg`,
    width: 16,
    height: 16,
    alt: 'Послушать',
  },

  [Option.keyMoments]: {
    src: `${STATIC_URL}/icons/icon_star.svg`,
    width: 16,
    height: 16,
    alt: 'Ключевые моменты',
  },
}

enum specWebinarAnchors {
  WATCH = 'watch',
  READ = 'read',
  LISTEN = 'listen',
  KEY_MOMENTS = 'keyMoments',
}

export { Option, OptionAliases, Options, OptionIcons, specWebinarAnchors }
